module.exports = __webpack_public_path__ + "img/1@2x (1).36990b20.png";